import React, { useEffect, useRef, useState } from 'react';
import { LoadingStepsList } from './LoadingStepsList';
import './RefreshLoadingModal.css';
import './LoadingStepsCarousel.css';

/**
 * Carrossel de um step por vez (estilo LoadingStepsList).
 * Ao avançar, o atual sobe e o próximo entra de baixo.
 */
export function LoadingStepsCarousel({
  steps = [],
  activeIndex = 0,
  className = '',
  variant = 'dark', // 'dark' | 'light'
}) {
  const safeIndex = Math.max(0, Math.min(activeIndex, Math.max(steps.length - 1, 0)));
  const [visibleIndex, setVisibleIndex] = useState(safeIndex);
  const [outgoingIndex, setOutgoingIndex] = useState(null);
  const [animKey, setAnimKey] = useState(0);
  const prevSafeRef = useRef(safeIndex);

  useEffect(() => {
    if (safeIndex === prevSafeRef.current) return;
    const leaving = prevSafeRef.current;
    prevSafeRef.current = safeIndex;
    setOutgoingIndex(leaving);
    setVisibleIndex(safeIndex);
    setAnimKey((k) => k + 1);

    const t = window.setTimeout(() => setOutgoingIndex(null), 420);
    return () => window.clearTimeout(t);
  }, [safeIndex]);

  if (!steps.length) return null;

  const outgoingStep = outgoingIndex != null ? steps[outgoingIndex] : null;
  const currentStep = steps[visibleIndex];
  const isLastDone = visibleIndex >= steps.length - 1 && safeIndex >= steps.length - 1;

  const rootClass = [
    'loading-steps-carousel',
    `loading-steps-carousel--${variant}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={rootClass} aria-live="polite" aria-atomic="true">
      <div className="loading-steps-carousel-viewport">
        {outgoingStep && (
          <div
            key={`out-${outgoingIndex}-${animKey}`}
            className="loading-steps-carousel-slide loading-steps-carousel-slide--out"
          >
            <LoadingStepsList
              iconMode="number"
              steps={[
                {
                  id: outgoingStep.id || `out-${outgoingIndex}`,
                  label: outgoingStep.label,
                  status: 'done',
                  stepNumber: outgoingIndex + 1,
                },
              ]}
            />
          </div>
        )}
        {currentStep && (
          <div
            key={`in-${visibleIndex}-${animKey}`}
            className={`loading-steps-carousel-slide${
              outgoingIndex != null ? ' loading-steps-carousel-slide--in' : ''
            }`}
          >
            <LoadingStepsList
              iconMode="number"
              steps={[
                {
                  id: currentStep.id || `in-${visibleIndex}`,
                  label: currentStep.label,
                  status: isLastDone && outgoingIndex == null ? 'done' : 'active',
                  stepNumber: visibleIndex + 1,
                },
              ]}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default LoadingStepsCarousel;
